import React, { useState, useEffect } from 'react';
import './RadioButtonGroup.css';
import RadioButton from '../RadioButtonGroup/RadioButton';
import logComponent from '../../common/logComponent';

export default function RadioButtonGroup({ initialSelection, reset, options, onChange, name, horizontal }) {
  const [selectedOption, setSelectedOption] = useState(initialSelection);
  if (logComponent('RadioButtonGroup')) { console.debug('RadioButtonGroup rendered'); }

  useEffect(() => {
    if (logComponent('RadioButtonGroup')) { console.debug('RadioButtonGroup useEffect [reset]'); }

    let selectedOption = initialSelection == null ? null : options.find(option => option.text === initialSelection.text);
    if(selectedOption != null)
      handleChange(selectedOption);
  }, [reset])

  const handleChange = (option) => {
    if (logComponent('RadioButtonGroup')) { console.debug('RadioButtonGroup handleChange'); }
    onChange({
      name: name,
      criteria: option.criteria,
      text: option.text
    });

    setSelectedOption(option);
  }

  const getInnerClassName = () => {
    return 'Radio-Button-Group__' + (horizontal == false ? 'vertical' : 'horizontal');
  }

  return (
    <div className="Radio-Button-Group">
      {(horizontal == null || horizontal === true) &&
        <div className="Radio-Button-Group__horizontal">
          {
            options.map(option =>
              <RadioButton
                key={option.text}
                option={option}
                name={name}
                selected={selectedOption != null && option.text === selectedOption.text}
                onChange={handleChange} />
            )
          }
        </div>
      }
      {horizontal != null && horizontal == false &&
        <div className="Radio-Button-Group__vertical">
          {
            options.map(option =>
              <RadioButton
                key={option.text}
                option={option}
                name={name}
                selected={selectedOption != null && option.text === selectedOption.text}
                onChange={handleChange} />
            )
          }
        </div>
      }
    </div>
  );
}